import { makeStyles, Theme } from '@material-ui/core/styles';
import tokens from 'tokens';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F5F5F5',
    padding: theme.spacing(2),
  },
  container: {
    textAlign: 'center',
    padding: theme.spacing(6),
    backgroundColor: 'white',
    borderRadius: theme.spacing(3),
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    maxWidth: 700,
    width: '100%',
    border: '1px solid #E0E0E0',
  },
  logoSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(4),
    gap: theme.spacing(2),
  },
  logoImage: {
    width: 48,
    height: 48,
    objectFit: 'contain',
  },
  fallbackLogo: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: '#362C4A',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoText: {
    color: 'white',
    fontSize: '1.5rem',
    fontWeight: 600,
    fontFamily: 'inherit',
  },
  brandText: {
    color: '#362C4A',
    fontSize: '1.5rem',
    fontWeight: 600,
    fontFamily: 'inherit',
  },
  contentSection: {
    marginBottom: theme.spacing(4),
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
  },
  mainIcon: {
    fontSize: '4rem',
    color: '#667eea',
  },
  title: {
    color: '#333333',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    fontSize: '2.2rem',
    fontFamily: 'inherit',
  },
  subtitle: {
    color: '#666666',
    marginBottom: theme.spacing(3),
    fontSize: '1.1rem',
    fontWeight: 400,
    fontFamily: 'inherit',
  },
  message: {
    color: '#666666',
    marginBottom: theme.spacing(4),
    fontSize: '1rem',
    lineHeight: 1.6,
    fontFamily: 'inherit',
    maxWidth: 500,
    margin: '0 auto',
    marginBottom: theme.spacing(4),
  },
  statusContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    alignItems: 'center',
    marginTop: theme.spacing(3),
  },
  statusItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    backgroundColor: '#F8F9FA',
    borderRadius: theme.spacing(1),
    border: '1px solid #E9ECEF',
  },
  statusIcon: {
    fontSize: '1.2rem',
    color: '#667eea',
  },
  statusText: {
    color: '#333333',
    fontSize: '0.9rem',
    fontWeight: 500,
    fontFamily: 'inherit',
  },
  footerSection: {
    borderTop: '1px solid #E0E0E0',
    paddingTop: theme.spacing(3),
  },
  footerText: {
    color: '#999999',
    fontSize: '0.9rem',
    fontFamily: 'inherit',
  },
}));
